import CircleLine from "@/components/common/log/circle-line";
import { formatDateTime } from "@/utils/dates";
import { formatDate } from "@/utils/format";
import { cn } from "@/utils/theme";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface Props {
  loadMore: () => void;
  hasMore?: boolean;
  isLoading?: boolean;
  isLoadingMore?: boolean;
  data: Array<{
    name: "result";
    value: true;
    type: "BOOLEAN";
    created_at: string;
  }>;
}

const Output = ({
  data,
  loadMore,
  hasMore,
  isLoading,
  isLoadingMore,
}: Props) => {
  console.log("Output data:", data);

  if (isLoading) {
    return (
      <div className="w-full flex items-center justify-center h-20">
        <Icon
          name="spinner-third"
          className="animate-spin text-lg text-on-disabled"
          type="far"
        />
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="w-full flex flex-col items-center justify-center h-20 text-center gap-2 px-4">
        <p className="text-body-quiet">
          No hay resultados de prueba disponibles.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col p-4 gap-4">
      <div className="relative">
        {data.map((d, index, { length }) => {
          return (
            <Log
              key={d.created_at}
              result={d.value ? "Verdadero" : "Falso"}
              date={formatDateTime(d.created_at)}
              index={index}
              isLast={index === length - 1}
            />
          );
        })}
      </div>
      {hasMore && (
        <Button
          type="button"
          onClick={loadMore}
          variant="ghost-blue"
          disabled={isLoadingMore}
        >
          Cargar más
          <Icon
            name={isLoadingMore ? "spinner-third" : "plus"}
            type="far"
            className={cn(isLoadingMore && "animate-spin")}
          />
        </Button>
      )}
    </div>
  );
};

export default Output;

const Log = ({
  result,
  date,
  index,
  isLast,
}: {
  result: string;
  index: number;
  isLast: boolean;
  date: string;
}) => {
  return (
    <div className={cn("flex gap-3 -mt-2", !isLast && "mb-0")}>
      <CircleLine
        option={index === 0 ? "init" : isLast ? "end" : "middle"}
        showLine={!isLast}
      />
      <div className={cn("flex-1", !isLast && "pb-6")}>
        {/* Description */}
        <h3 className="mb-2 text-body">Resultado de prueba: {result}</h3>

        {/* Date */}
        <div className="text-sm text-body-quiet capitalize">
          {formatDate(date)}
        </div>
      </div>
    </div>
  );
};
